import PropTypes from "prop-types"
import { useEffect } from "react"
import { useSelector } from "react-redux"

import useAffirm from "helpers/checkout/use-affirm"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

const Affirm = ({ price }) => {
  const affirmLoaded = useAffirm()
  const { isTablet } = useWindowDimensions()
  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  useEffect(() => {
    if (!affirmLoaded) return

    if (
      typeof window.affirm !== "undefined" &&
      window.affirm.ui &&
      window.affirm.ui.refresh
    ) {
      window.affirm.ui.refresh()
    }
  }, [affirmLoaded, isTablet, price])

  if (!price) return null

  return (
    <div
      className={cn(
        pdpPricingHierarchyExp === 1
          ? "text-grey-500 text-11 tablet:text-right block cursor-pointer text-left font-semibold [&_a]:underline [&_a]:hover:no-underline [&_a]:focus:no-underline"
          : "text-link text-12 block cursor-pointer [&>span]:border-b"
      )}
      style={{ minHeight: "18px" }}
    >
      <span
        className="affirm-as-low-as"
        // data-affirm-color={logoColor}
        data-amount={price}
        data-learnmore-show="false"
        data-page-type="product"
      />
    </div>
  )
}

Affirm.propTypes = {
  price: PropTypes.number,
}

export default Affirm
